import React from 'react';
import { render } from 'react-dom';
import { Router, Switch, Route } from 'react-router-dom';
import history from './history';
import App from './components/App';
import Register from './components/Register';
import Login from './components/Login';
import Login2 from './components/Login2';
import Login3 from './components/Login3';
import Login4 from './components/Login4';
import LoginOptions from './components/LoginOptions';
import LoginOptions2 from './components/LoginOptions2';
import PhoneAuthentication from './components/PhoneAuthentication';
import PhoneAuthentication2 from './components/PhoneAuthentication2';
import TokenAuthentication from './components/TokenAuthentication';
import TokenAuthentication2 from './components/TokenAuthentication2';
import TokenAuthentication3 from './components/TokenAuthentication3';
import OTPAuthentication from './components/OTPAuthentication';
import ConductAlexanderk from './components/ConductAlexanderk';
import ConductAnandat from './components/ConductAnandat';
import ConductAnantayak from './components/ConductAnantayak';
import ConductAngieo from './components/ConductAngieo';
import ConductAutp from './components/ConductAutp';
import ConductBillyz from './components/ConductBillyz';
import ConductBorwonr from './components/ConductBorwonr';
import ConductCarolync from './components/ConductCarolync';
import ConductChaiwatt from './components/ConductChaiwatt';
import ConductChatchawane from './components/ConductChatchawane';
import ConductChayanind from './components/ConductChayanind';
import ConductChoosakp from './components/ConductChoosakp';
import ConductDanaiy from './components/ConductDanaiy';
import ConductEricc from './components/ConductEricc';
import ConductJanicej from './components/ConductJanicej';
import ConductJeerawita from './components/ConductJeerawita';
import ConductJiaminb from './components/ConductJiaminb';
import ConductKanina from './components/ConductKanina';
import ConductKanokphonc from './components/ConductKanokphonc';
import ConductKridsadad from './components/ConductKridsadad';
import ConductLoonweewatt from './components/ConductLoonweewatt';
import ConductLulladaa from './components/ConductLulladaa';
import ConductMetapornc from './components/ConductMetapornc';
import ConductMichion from './components/ConductMichion';
import ConductNamont from './components/ConductNamont';
import ConductNapolp from './components/ConductNapolp';
import ConductNarongritn from './components/ConductNarongritn';
import ConductNaruporns from './components/ConductNaruporns';
import ConductNatsawittau from './components/ConductNatsawittau';
import ConductNattasuth from './components/ConductNattasuth';
import ConductNatthaphati from './components/ConductNatthaphati';
import ConductNew from './components/ConductNew';
import ConductNirunc from './components/ConductNirunc';
import ConductNitchakarnt from './components/ConductNitchakarnt';
import ConductPatanins from './components/ConductPatanins';
import ConductPattapongc from './components/ConductPattapongc';
import ConductPattarananp from './components/ConductPattarananp';
import ConductPisutk from './components/ConductPisutk';
import ConductRatchadapornn from './components/ConductRatchadapornn';
import ConductRatcharatp from './components/ConductRatcharatp';
import ConductRonbanchoba from './components/ConductRonbanchoba';
import ConductSanphets from './components/ConductSanphets';
import ConductShintarok from './components/ConductShintarok';
import ConductSiwathornr from './components/ConductSiwathornr';
import ConductSomchaic from './components/ConductSomchaic';
import ConductSreytiah from './components/ConductSreytiah';
import ConductSupachais from './components/ConductSupachais';
import ConductSupapimpisap from './components/ConductSupapimpisap';
import ConductSurateer from './components/ConductSurateer';
import ConductSurink from './components/ConductSurink';
import ConductTarah from './components/ConductTarah';
import ConductTeerayutp from './components/ConductTeerayutp';
import ConductThakhunk from './components/ConductThakhunk';
import ConductThanyapatp from './components/ConductThanyapatp';
import ConductThongchait from './components/ConductThongchait';
import ConductThongchomphunutr from './components/ConductThongchomphunutr';
import ConductTirawana from './components/ConductTirawana';
import ConductUraveet from './components/ConductUraveet';
import ConductWacharapongs from './components/ConductWacharapongs';
import ConductWinyuc from './components/ConductWinyuc';
import ConductWitchayapongp from './components/ConductWitchayapongp';
import ConductWorapotb from './components/ConductWorapotb';
import ConductYanint from './components/ConductYanint';
import ConductYaranyapohnk from './components/ConductYaranyapohnk';
import ConductAndrewl from './components/ConductAndrewl';
import ConductPanyaphatk from './components/ConductPanyaphatk';
import ConductPongworakornp from './components/ConductPongworakornp';
import ConductSunyal from './components/ConductSunyal';
import ConductTanapolp from './components/ConductTanapolp';
import ConductThomasm from './components/ConductThomasm';
import ConductPanupats from './components/ConductPanupats';
import ConductAsdawutc from './components/ConductAsdawutc';
import ConductChanchita from './components/ConductChanchita';
import ConductIssariyapar from './components/ConductIssariyapar';
import ConductJacquesp from './components/ConductJacquesp';
import ConductMatsakaj from './components/ConductMatsakaj';
import ConductNapasanunv from './components/ConductNapasanunv';
import ConductNaphatsorny from './components/ConductNaphatsorny';
import ConductNutchan from './components/ConductNutchan';
import ConductPawanratc from './components/ConductPawanratc';
import ConductSantis from './components/ConductSantis';
import ConductWannatouchp from './components/ConductWannatouchp';
import ConductCrystalmd from './components/ConductCrystalmd';
import ConductJamesrh from './components/ConductJamesrh';
import ConductNatthapony from './components/ConductNatthapony';
import ConductNueas from './components/ConductNueas';
import ConductArchirawishp from './components/ConductArchirawishp';
import ConductKarnts from './components/ConductKarnts';
import ConductKittipatw from './components/ConductKittipatw';
import ConductManussaporne from './components/ConductManussaporne';
import ConductOrawanp from './components/ConductOrawanp';
import ConductPakawadn from './components/ConductPakawadn';
import ConductPraewpuns from './components/ConductPraewpuns';
import ConductPats from './components/ConductPats';
import ConductRiradav from './components/ConductRiradav';
import ConductSirawichu from './components/ConductSirawichu';
import ConductSuphodh from './components/ConductSuphodh';
import ConductSurachett from './components/ConductSurachett';
import ConductChaiyutv from './components/ConductChaiyutv';
import ConductChakchaia from './components/ConductChakchaia';
import ConductMarcop from './components/ConductMarcop';
import ConductPongnarts from './components/ConductPongnarts';
import ConductShinehl from './components/ConductShinehl';
import ConductSuphatchayab from './components/ConductSuphatchayab';
import ConductVunqt from './components/ConductVunqt';
import ConductSuteed from './components/ConductSuteed';
import ConductAthichonmf from './components/ConductAthichonmf';
import ConductBarbarab from './components/ConductBarbarab';
import ConductJarunnops from './components/ConductJarunnops';
import ConductKank from './components/ConductKank';
import ConductKanyaphatp from './components/ConductKanyaphatp';
import ConductMarceld from './components/ConductMarceld';
import ConductNannaphatp from './components/ConductNannaphatp';
import ConductNatdanaid from './components/ConductNatdanaid';
import ConductPanyasuphak from './components/ConductPanyasuphak';
import ConductRattapongp from './components/ConductRattapongp';
import ConductWatcharapongb from './components/ConductWatcharapongb';
import ConductNarat from './components/ConductNarat';
import ConductCheiax from './components/ConductCheiax';
import ConductOrnranatp from './components/ConductOrnranatp';
import ConductNaruekarink from './components/ConductNaruekarink';
import ConductCarinad from './components/ConductCarinad';
import ConductEkasitw from './components/ConductEkasitw';
import ConductNaras from './components/ConductNaras';
import ConductNattawuta from './components/ConductNattawuta';
import ConductNichaj from './components/ConductNichaj';
import ConductNiwats from './components/ConductNiwats';
import ConductPraphatpongy from './components/ConductPraphatpongy';
import ConductTorritb from './components/ConductTorritb';
import ConductBenjaminb from './components/ConductBenjaminb';
import ConductMarks from './components/ConductMarks';
import ConductMarvins from './components/ConductMarvins';
import ConductMitts from './components/ConductMitts';
import ConductKansinees from './components/ConductKansinees';
import ConductNarns from './components/ConductNarns';
import ConductTylerb from './components/ConductTylerb';
import ConductWyonab from './components/ConductWyonab';
import ConductZaidena from './components/ConductZaidena';
import ConductAmornpont from './components/ConductAmornpont';
import ConductJasona from './components/ConductJasona';
import ConductKosinm from './components/ConductKosinm';
import ConductNiratb from './components/ConductNiratb';
import ConductPatawank from './components/ConductPatawank';
import ConductPawatchakornh from './components/ConductPawatchakornh';
import ConductChanmethap from './components/ConductChanmethap';
import ConductNithiss from './components/ConductNithiss';
import ConductPhusins from './components/ConductPhusins';
import ConductThanaip from './components/ConductThanaip';
import ConductPiroontipl from './components/ConductPiroontipl';
import ConductXinrongw from './components/ConductXinrongw';
import ConductLinh from './components/ConductLinh';
import ConductNadaphatn from './components/ConductNadaphatn';
import ConductNataphatn from './components/ConductNataphatn';
import ConductNaprachm from './components/ConductNaprachm';
import ConductJaiklal from './components/ConductJaiklal';
import ConductNiksak from './components/ConductNiksak';
import ConductParicharts from './components/ConductParicharts';
import ConductPhattarakritl from './components/ConductPhattarakritl';
import ConductPhuphumj from './components/ConductPhuphumj';
import ConductPiyabutrl from './components/ConductPiyabutrl';
import ConductVaayuk from './components/ConductVaayuk';
import ConductWichaic from './components/ConductWichaic';
import ConductStefank from './components/ConductStefank';
import ConductShosont from './components/ConductShosont';
import ConductKarlr from './components/ConductKarlr';
import ConductSunchuym from './components/ConductSunchuym';
import ConductPathikornk from './components/ConductPathikornk';
import ConductRatarmontrees from './components/ConductRatarmontrees';
import ConductKannikad from './components/ConductKannikad';
import ConductZarawink from './components/ConductZarawink';
import ConductJohnh from './components/ConductJohnh';
import ConductSombatt from './components/ConductSombatt';
import ConductTeeraratb from './components/ConductTeeraratb';
import ConductChucheeps from './components/ConductChucheeps';
import ConductRakchanokc from './components/ConductRakchanokc';
import ConductNarumolt from './components/ConductNarumolt';
import ConductRatchadaporns from './components/ConductRatchadaporns';
import ConductWatcharapols from './components/ConductWatcharapols';
import ConductWisutl from './components/ConductWisutl';
import ConductPipatphongw from './components/ConductPipatphongw';
import ConductFuengwichm from './components/ConductFuengwichm';
import ConductKittisaks from './components/ConductKittisaks';
import ConductSiriphornm from './components/ConductSiriphornm';
import ConductTarnnamthips from './components/ConductTarnnamthips';
import ConductSukunyak from './components/ConductSukunyak';
import ConductJanyaporns from './components/ConductJanyaporns';
import ConductRattanas from './components/ConductRattanas';
import ConductPhasinl from './components/ConductPhasinl';
import ConductPhurint from './components/ConductPhurint';
import ConductMatthewp from './components/ConductMatthewp';
import ConductNonthapornk from './components/ConductNonthapornk';
import ConductAnuchaw from './components/ConductAnuchaw';
import ConductLolas from './components/ConductLolas';
import ConductJonathanc from './components/ConductJonathanc';
import ConductKetkanoka from './components/ConductKetkanoka';
import ConductPobkhunt from './components/ConductPobkhunt';
import ConductPimphisal from './components/ConductPimphisal';
import ConductPurip from './components/ConductPurip';
import ConductPimpidat from './components/ConductPimpidat';
import ConductNechayas from './components/ConductNechayas';
import ConductPawornwichw from './components/ConductPawornwichw';
import ConductRakhunt from './components/ConductRakhunt';
import ConductPunnapatw from './components/ConductPunnapatw';
import ConductAmornphitk from './components/ConductAmornphitk';
import ConductThantnyim from './components/ConductThantnyim';
import ConductAmornphant from './components/ConductAmornphant';
import ConductPiyachutc from './components/ConductPiyachutc';
import ConductWorapopk from './components/ConductWorapopk';
import ConductAnnar from './components/ConductAnnar';
import ConductDarann from './components/ConductDarann';
import ConductAugusts from './components/ConductAugusts';
import ConductThammachartt from './components/ConductThammachartt';
import ConductAndreif from './components/ConductAndreif';
import ConductLiudmilam from './components/ConductLiudmilam';
import ConductPorametn from './components/ConductPorametn';
import ConductPhimmadak from './components/ConductPhimmadak';
import ConductJirananu from './components/ConductJirananu';
import ConductPichamonc from './components/ConductPichamonc';
import ConductParinb from './components/ConductParinb';
import ConductThanachotec from './components/ConductThanachotec';
import ConductWissarutm from './components/ConductWissarutm';
import ConductPummad from './components/ConductPummad';
import ConductChoochaic from './components/ConductChoochaic';
import ConductBusayarinr from './components/ConductBusayarinr';
import ConductAurathail from './components/ConductAurathail';
import ConductParamir from './components/ConductParamir';
import ConductSalineeb from './components/ConductSalineeb';
import ConductWannarats from './components/ConductWannarats';
import ConductKittichoten from './components/ConductKittichoten';
import ConductTheerathasp from './components/ConductTheerathasp';
import ConductAnukulc from './components/ConductAnukulc';
import ConductNatchanonk from './components/ConductNatchanonk';
import ConductPunnawatk from './components/ConductPunnawatk';
import ConductTechathatw from './components/ConductTechathatw';
import ConductYothsayaw from './components/ConductYothsayaw';
import ConductPuttd from './components/ConductPuttd';
import ConductSirapopes from './components/ConductSirapopes';
import ConductMaytapornc from './components/ConductMaytapornc';
import ConductPittayac from './components/ConductPittayac';
import ConductPordeer from './components/ConductPordeer';
import ConductPemikar from './components/ConductPemikar';
import ConductPattarapony from './components/ConductPattarapony';
import ConductPiyanats from './components/ConductPiyanats';
import ConductRatchaninp from './components/ConductRatchaninp';
import ConductNatnateep from './components/ConductNatnateep';
import ConductBowwonlukc from './components/ConductBowwonlukc';
import ConductPoonkanuto from './components/ConductPoonkanuto';
import ConductSengdaviengd from './components/ConductSengdaviengd';
import ConductPatwareek from './components/ConductPatwareek';
import BioAlexanderk from './components/BioAlexanderk';
import BioAnandat from './components/BioAnandat';
import BioAnantayak from './components/BioAnantayak';
import BioAngieo from './components/BioAngieo';
import BioAutp from './components/BioAutp';
import BioBillyz from './components/BioBillyz';
import BioBorwonr from './components/BioBorwonr';
import BioCarolync from './components/BioCarolync';
import BioChaiwatt from './components/BioChaiwatt';
import BioChatchawane from './components/BioChatchawane';
import BioChayanind from './components/BioChayanind';
import BioChoosakp from './components/BioChoosakp';
import BioDanaiy from './components/BioDanaiy';
import BioEricc from './components/BioEricc';
import BioJanicej from './components/BioJanicej';
import BioJeerawita from './components/BioJeerawita';
import BioJiaminb from './components/BioJiaminb';
import BioKanina from './components/BioKanina';
import BioKanokphonc from './components/BioKanokphonc';
import BioKridsadad from './components/BioKridsadad';
import BioLoonweewatt from './components/BioLoonweewatt';
import BioLulladaa from './components/BioLulladaa';
import BioMetapornc from './components/BioMetapornc';
import BioMichion from './components/BioMichion';
import BioNamont from './components/BioNamont';
import BioNapolp from './components/BioNapolp';
import BioNarongritn from './components/BioNarongritn';
import BioNaruporns from './components/BioNaruporns';
import BioNatsawittau from './components/BioNatsawittau';
import BioNattasuth from './components/BioNattasuth';
import BioNatthaphati from './components/BioNatthaphati';
import BioNew from './components/BioNew';
import BioNirunc from './components/BioNirunc';
import BioNitchakarnt from './components/BioNitchakarnt';
import BioPatanins from './components/BioPatanins';
import BioPattapongc from './components/BioPattapongc';
import BioPattarananp from './components/BioPattarananp';
import BioPisutk from './components/BioPisutk';
import BioRatchadapornn from './components/BioRatchadapornn';
import BioRatcharatp from './components/BioRatcharatp';
import BioRonbanchoba from './components/BioRonbanchoba';
import BioSanphets from './components/BioSanphets';
import BioShintarok from './components/BioShintarok';
import BioSiwathornr from './components/BioSiwathornr';
import BioSomchaic from './components/BioSomchaic';
import BioSreytiah from './components/BioSreytiah';
import BioSupachais from './components/BioSupachais';
import BioSupapimpisap from './components/BioSupapimpisap';
import BioSurateer from './components/BioSurateer';
import BioSurink from './components/BioSurink';
import BioTarah from './components/BioTarah';
import BioTeerayutp from './components/BioTeerayutp';
import BioThakhunk from './components/BioThakhunk';
import BioThanyapatp from './components/BioThanyapatp';
import BioThongchait from './components/BioThongchait';
import BioThongchomphunutr from './components/BioThongchomphunutr';
import BioTirawana from './components/BioTirawana';
import BioUraveet from './components/BioUraveet';
import BioWacharapongs from './components/BioWacharapongs';
import BioWinyuc from './components/BioWinyuc';
import BioWitchayapongp from './components/BioWitchayapongp';
import BioWorapotb from './components/BioWorapotb';
import BioYanint from './components/BioYanint';
import BioYaranyapohnk from './components/BioYaranyapohnk';
import BioAndrewl from './components/BioAndrewl';
import BioPanyaphatk from './components/BioPanyaphatk';
import BioPongworakornp from './components/BioPongworakornp';
import BioSunyal from './components/BioSunyal';
import BioChanchita from './components/BioChanchita';
import BioIssariyapar from './components/BioIssariyapar';
import BioJacquesp from './components/BioJacquesp';
import BioMatsakaj from './components/BioMatsakaj';
import BioNapasanunv from './components/BioNapasanunv';
import BioNaphatsorny from './components/BioNaphatsorny';
import BioNutchan from './components/BioNutchan';
import BioPawanratc from './components/BioPawanratc';
import BioSantis from './components/BioSantis';
import BioWannatouchp from './components/BioWannatouchp';
import BioTanapolp from './components/BioTanapolp';
import BioThomasm from './components/BioThomasm';
import BioPanupats from './components/BioPanupats';
import BioAsdawutc from './components/BioAsdawutc';
import BioCrystalmd from './components/BioCrystalmd';
import BioJamesrh from './components/BioJamesrh';
import BioNatthapony from './components/BioNatthapony';
import BioNueas from './components/BioNueas';
import BioArchirawishp from './components/BioArchirawishp';
import BioKarnts from './components/BioKarnts';
import BioKittipatw from './components/BioKittipatw';
import BioManussaporne from './components/BioManussaporne';
import BioOrawanp from './components/BioOrawanp';
import BioPakawadn from './components/BioPakawadn';
import BioPats from './components/BioPats';
import BioPraewpuns from './components/BioPraewpuns';
import BioRiradav from './components/BioRiradav';
import BioSirawichu from './components/BioSirawichu';
import BioSuphodh from './components/BioSuphodh';
import BioSurachett from './components/BioSurachett';
import BioChaiyutv from './components/BioChaiyutv';
import BioChakchaia from './components/BioChakchaia';
import BioMarcop from './components/BioMarcop';
import BioPongnarts from './components/BioPongnarts';
import BioShinehl from './components/BioShinehl';
import BioSuphatchayab from './components/BioSuphatchayab';
import BioSuteed from './components/BioSuteed';
import BioVunqt from './components/BioVunqt';
import BioAthichonmf from './components/BioAthichonmf';
import BioBarbarab from './components/BioBarbarab';
import BioJarunnops from './components/BioJarunnops';
import BioKank from './components/BioKank';
import BioKanyaphatp from './components/BioKanyaphatp';
import BioMarceld from './components/BioMarceld';
import BioNannaphatp from './components/BioNannaphatp';
import BioNatdanaid from './components/BioNatdanaid';
import BioPanyasuphak from './components/BioPanyasuphak';
import BioRattapongp from './components/BioRattapongp';
import BioWatcharapongb from './components/BioWatcharapongb';
import BioNarat from './components/BioNarat';
import BioCheiax from './components/BioCheiax';
import BioOrnranatp from './components/BioOrnranatp';
import BioNaruekarink from './components/BioNaruekarink';
import BioCarinad from './components/BioCarinad';
import BioEkasitw from './components/BioEkasitw';
import BioNaras from './components/BioNaras';
import BioNattawuta from './components/BioNattawuta';
import BioNichaj from './components/BioNichaj';
import BioNiwats from './components/BioNiwats';
import BioPraphatpongy from './components/BioPraphatpongy';
import BioTorritb from './components/BioTorritb';
import BioBenjaminb from './components/BioBenjaminb';
import BioKansinees from './components/BioKansinees';
import BioMarks from './components/BioMarks';
import BioMarvins from './components/BioMarvins';
import BioMitts from './components/BioMitts';
import BioNarns from './components/BioNarns';
import BioTylerb from './components/BioTylerb';
import BioWyonab from './components/BioWyonab';
import BioZaidena from './components/BioZaidena';
import BioAmornpont from './components/BioAmornpont';
import BioKosinm from './components/BioKosinm';
import BioNiratb from './components/BioNiratb';
import BioPatawank from './components/BioPatawank';
import BioPawatchakornh from './components/BioPawatchakornh';
import BioJasona from './components/BioJasona';
import BioChanmethap from './components/BioChanmethap';
import BioNithiss from './components/BioNithiss';
import BioPhusins from './components/BioPhusins';
import BioThanaip from './components/BioThanaip';
import BioPiroontipl from './components/BioPiroontipl';
import BioXinrongw from './components/BioXinrongw';
import BioLinh from './components/BioLinh';
import BioNadaphatn from './components/BioNadaphatn';
import BioNataphatn from './components/BioNataphatn';
import BioNaprachm from './components/BioNaprachm';
import BioJaiklal from './components/BioJaiklal';
import BioNiksak from './components/BioNiksak';
import BioParicharts from './components/BioParicharts';
import BioPhattarakritl from './components/BioPhattarakritl';
import BioPhuphumj from './components/BioPhuphumj';
import BioPiyabutrl from './components/BioPiyabutrl';
import BioVaayuk from './components/BioVaayuk';
import BioWichaic from './components/BioWichaic';
import BioStefank from './components/BioStefank';
import BioShosont from './components/BioShosont';
import BioKarlr from './components/BioKarlr';
import BioSunchuym from './components/BioSunchuym';
import BioPathikornk from './components/BioPathikornk';
import BioSalineeb from './components/BioSalineeb';
import BioAnukulc from './components/BioAnukulc';
import BioNatchanonk from './components/BioNatchanonk';
import BioPunnawatk from './components/BioPunnawatk';
import BioTechathatw from './components/BioTechathatw';
import BioYothsayaw from './components/BioYothsayaw';
import BioPuttd from './components/BioPuttd';
import BioSirapopes from './components/BioSirapopes';
import BioPatwareek from './components/BioPatwareek';
import BioPittayac from './components/BioPittayac';
import BioPordeer from './components/BioPordeer';
import BioPemikar from './components/BioPemikar';
import BioPattarapony from './components/BioPattarapony';
import BioPiyanats from './components/BioPiyanats';
import BioRatchaninp from './components/BioRatchaninp';
import BioNatnateep from './components/BioNatnateep';
import BioBowwonlukc from './components/BioBowwonlukc';
import BioWannarats from './components/BioWannarats';
import BioMaytapornc from './components/BioMaytapornc';
import BioNechayas from './components/BioNechayas';
import BioPawornwichw from './components/BioPawornwichw';
import BioRatchadaporns from './components/BioRatchadaporns';
import BioTarnnamthips from './components/BioTarnnamthips';
import BioRattanas from './components/BioRattanas';
import BioRakhunt from './components/BioRakhunt';
import BioPobkhunt from './components/BioPobkhunt';
import BioAnnar from './components/BioAnnar';
import BioDarann from './components/BioDarann';
import BioPunnapatw from './components/BioPunnapatw';
import BioPimphisal from './components/BioPimphisal';
import BioNonthapornk from './components/BioNonthapornk';
import BioSombatt from './components/BioSombatt';
import BioTeeraratb from './components/BioTeeraratb';
import BioChucheeps from './components/BioChucheeps';
import BioRakchanokc from './components/BioRakchanokc';
import BioWatcharapols from './components/BioWatcharapols';
import BioNarumolt from './components/BioNarumolt';
import BioWisutl from './components/BioWisutl';
import BioPipatphongw from './components/BioPipatphongw';
import BioFuengwichm from './components/BioFuengwichm';
import BioKittisaks from './components/BioKittisaks';
import BioSiriphornm from './components/BioSiriphornm';
import BioPhasinl from './components/BioPhasinl';
import BioSukunyak from './components/BioSukunyak';
import BioAnuchaw from './components/BioAnuchaw';
import BioJanyaporns from './components/BioJanyaporns';
import BioLolas from './components/BioLolas';
import BioPhurint from './components/BioPhurint';
import BioMatthewp from './components/BioMatthewp';
import BioJonathanc from './components/BioJonathanc';
import BioPurip from './components/BioPurip';
import BioPimpidat from './components/BioPimpidat';
import BioKetkanoka from './components/BioKetkanoka';
import BioAmornphitk from './components/BioAmornphitk';
import BioThantnyim from './components/BioThantnyim';
import BioAmornphant from './components/BioAmornphant';
import BioThammachartt from './components/BioThammachartt';
import BioPiyachutc from './components/BioPiyachutc';
import BioAndreif from './components/BioAndreif';
import BioLiudmilam from './components/BioLiudmilam';
import BioAugusts from './components/BioAugusts';
import BioWorapopk from './components/BioWorapopk';
import BioPorametn from './components/BioPorametn';
import BioJirananu from './components/BioJirananu';
import BioPichamonc from './components/BioPichamonc';
import BioParinb from './components/BioParinb';
import BioPhimmadak from './components/BioPhimmadak';
import BioJohnh from './components/BioJohnh';
import BioRatarmontrees from './components/BioRatarmontrees';
import BioKannikad from './components/BioKannikad';
import BioZarawink from './components/BioZarawink';
import BioWissarutm from './components/BioWissarutm';
import BioPummad from './components/BioPummad';
import BioChoochaic from './components/BioChoochaic';
import BioBusayarinr from './components/BioBusayarinr';
import BioAurathail from './components/BioAurathail';
import BioKittichoten from './components/BioKittichoten';
import BioTheerathasp from './components/BioTheerathasp';
import BioPoonkanuto from './components/BioPoonkanuto';
import BioSengdaviengd from './components/BioSengdaviengd';
import BioParamir from './components/BioParamir';
import BioThanachotec from './components/BioThanachotec';
import ConductYihaow from './components/ConductYihaow';
import BioYihaow from './components/BioYihaow';
import ConductAniwatl from './components/ConductAniwatl';
import BioAniwatl from './components/BioAniwatl';
import ConductEugenea from './components/ConductEugenea';
import BioEugenea from './components/BioEugenea';
import ConductWiyadaj from './components/ConductWiyadaj';
import BioWiyadaj from './components/BioWiyadaj';
import ConductThanasons from './components/ConductThanasons';
import BioThanasons from './components/BioThanasons';
import ConductNaphatradaq from './components/ConductNaphatradaq';
import BioNaphatradaq from './components/BioNaphatradaq';
import ConductSathawathak from './components/ConductSathawathak';
import BioSathawathak from './components/BioSathawathak';
import ConductChayaphatk from './components/ConductChayaphatk';
import BioChayaphatk from './components/BioChayaphatk';
import ConductPasuthan from './components/ConductPasuthan';
import BioPasuthan from './components/BioPasuthan';
import ConductJaruwann from './components/ConductJaruwann';
import BioJaruwann from './components/BioJaruwann';
import ConductThornthepk from './components/ConductThornthepk';
import BioThornthepk from './components/BioThornthepk';
import ConductTirawutn from './components/ConductTirawutn';
import BioTirawutn from './components/BioTirawutn';
import ConductYuthanas from './components/ConductYuthanas';
import BioYuthanas from './components/BioYuthanas';
import ConductKrittitatw from './components/ConductKrittitatw';
import BioKrittitatw from './components/BioKrittitatw';
import ConductPhanuphongk from './components/ConductPhanuphongk';
import BioPhanuphongk from './components/BioPhanuphongk';
import Dojos from './components/dojos';
import ClassesRenbukan from './components/ClassesRenbukan';
import ClassesBMZ from './components/ClassesBMZ';
import ClassesSattahip from './components/ClassesSattahip';
import ClassesTukSomRangsit from './components/ClassesTukSomRangsit';
import ClassesTukSomRomKaow from './components/ClassesTukSomRomKaow';
import ClassesWongwianYai from './components/ClassesWongwianYai';
import ClassesFudokan from './components/ClassesFudokan';
import ClassesLumpini from './components/ClassesLumpini';
import ClassesMasakatsu from './components/ClassesMasakatsu';
import ClassesChiangMai from './components/ClassesChiangMai';
import ClassesChula from './components/ClassesChula';
import ClassesKorat from './components/ClassesKorat';
import AllClasses from './components/AllClasses';
import RosterRenbukan from './components/RosterRenbukan';
import RosterChula from './components/RosterChula';
import RosterBMZ from './components/RosterBMZ';
import RosterSattahip from './components/RosterSattahip';
import RosterTuksom from './components/RosterTuksom';
import RosterKorat from './components/RosterKorat';
import RosterWongwianyai from './components/RosterWongwianyai';
import RosterMasakatsu from './components/RosterMasakatsu';
import RosterPhraKhanong from './components/RosterPhraKhanong';
import RosterLumpini from './components/RosterLumpini';
import RosterFudokan from './components/RosterFudokan';
import RosterChiangmai from './components/RosterChiangmai';
import RosterAll from './components/RosterAll';
import SecretPage from './components/SecretPage';
import KeysGenerator from './components/KeysGenerator';
import PINCodeAuthentication from './components/PINCodeAuthentication';
import OTPAuthentication2 from './components/OTPAuthentication2';
import ShowTokens from './components/ShowTokens';
import ShowTokens2 from './components/ShowTokens2';
import ShowTokens3 from './components/ShowTokens3';
import AlgorithmOptions from './components/AlgorithmOptions';
import Rs256Signature from './components/Rs256Signature';
import UploadSlip from './components/UploadSlip';
import UploadSlip2 from './components/UploadSlip2';
import UploadQRCode from './components/UploadQRCode';
import SetMessage from './components/SetMessage';
import MonitorSummary from './components/MonitorSummary';
import Blocks from './components/Blocks';
import ConductTransaction from './components/ConductTransaction';
import TransactionPool from './components/TransactionPool';
import QRCodeGenerator from './components/QRCodeGenerator';
import Test080325 from './components/Test080325';
import Test230325 from './components/Test230325';
import Test140625 from './components/Test140625';
import Test220625 from './components/Test220625';
import Test070925 from './components/Test070925';
import Test140925 from './components/Test140925';
import Test071225 from './components/Test071225';
import Test211225 from './components/Test211225';
import Test150326 from './components/Test150326';
import Test220326 from './components/Test220326';
import Test140626 from './components/Test140626';
import Test210626 from './components/Test210626';
import Test200926 from './components/Test200926';
import Test270926 from './components/Test270926';
import TestResults080325 from './components/TestResults080325';
import TestResults230325 from './components/TestResults230325';
import TestResults140625 from './components/TestResults140625';
import TestResults220625 from './components/TestResults220625';
import TestResults070925 from './components/TestResults070925';
import TestResults140925 from './components/TestResults140925';
import TestResults071225 from './components/TestResults071225';
import TestResults211225 from './components/TestResults211225';
import TestResults150326 from './components/TestResults150326';
import TestResults220326 from './components/TestResults220326';
import TestResults140626 from './components/TestResults140626';
import TestResults210626 from './components/TestResults210626';
import TestResults200926 from './components/TestResults200926';
import TestResults270926 from './components/TestResults270926';
import SendEmailForm from './components/SendEmailForm';
import MeetingMembers from './components/MeetingMembers';
import Shop from './components/Shop';
import ShopGi from './components/ShopGi';
import ShopHakamaBelts from './components/ShopHakamaBelts';
import ShopShirts from './components/ShopShirts';
import ShopShirts1 from './components/ShopShirts1';
import ShopShirts2 from './components/ShopShirts2';
import ShopShirts3 from './components/ShopShirts3';
import ShopShirts4 from './components/ShopShirts4';
import UploadShirts1 from './components/UploadShirts1';
import UploadShirts2 from './components/UploadShirts2';
import UploadShirts3 from './components/UploadShirts3';
import UploadShirts4 from './components/UploadShirts4';
import ShopAccessories from './components/ShopAccessories';
import ShopWeapons from './components/ShopWeapons';
import Instructors from './components/Instructors';
import Seminar041025 from './components/Seminar041025';
import Seminar051025 from './components/Seminar051025';
import SeminarBMZ1 from './components/SeminarBMZ1';
import SeminarBMZ2 from './components/SeminarBMZ2';
import SeminarChiangmai1 from './components/SeminarChiangmai1';
import SeminarChiangmai2 from './components/SeminarChiangmai2';
import SeminarChina1 from './components/SeminarChina1';
import SeminarChina2 from './components/SeminarChina2';
import SeminarChula1 from './components/SeminarChula1';
import SeminarChula2 from './components/SeminarChula2';
import SeminarDindang1 from './components/SeminarDindang1';
import SeminarDindang2 from './components/SeminarDindang2';
import SeminarFudokan1 from './components/SeminarFudokan1';
import SeminarFudokan2 from './components/SeminarFudokan2';
import SeminarHongkong1 from './components/SeminarHongkong1';
import SeminarHongkong2 from './components/SeminarHongkong2';
import SeminarMasakatsu1 from './components/SeminarMasakatsu1';
import SeminarMasakatsu2 from './components/SeminarMasakatsu2';
import SeminarKorat1 from './components/SeminarKorat1';
import SeminarKorat2 from './components/SeminarKorat2';
import SeminarMalaysia1 from './components/SeminarMalaysia1';
import SeminarMalaysia2 from './components/SeminarMalaysia2';
import SeminarTuksom1 from './components/SeminarTuksom1';
import SeminarTuksom2 from './components/SeminarTuksom2';
import SeminarWongwianyai1 from './components/SeminarWongwianyai1';
import SeminarWongwianyai2 from './components/SeminarWongwianyai2';
import SeminarMarine1 from './components/SeminarMarine1';
import SeminarMarine2 from './components/SeminarMarine2';
import SeminarSingapore1 from './components/SeminarSingapore1';
import SeminarSingapore2 from './components/Seminarsingapore2';
import SeminarKarnt from './components/SeminarKarnt';
import SeminarAishoonteo from './components/SeminarAishoonteo';
import CertificatesList from './components/CertificatesList';
import GoshinJitsu from './components/GoshinJitsu';
import WeaponsClass from './components/WeaponsClass';
import ForgetPassword from './components/ForgetPassword';
import ResetPassword from './components/ResetPassword';
import PaymentMethods from './components/PaymentMethods';
import CreditcardOptions from './components/CreditcardOptions';
import LoginCredits100 from './components/LoginCredits100';
import ClaimCredits100 from './components/ClaimCredits100';
import StripePage100 from './components/StripePage100';
import TestRecords from './components/TestRecords';
import Forms from './components/Forms';
import Search from './components/Search';
import Articles from './components/Articles';
import Shimbun from './components/Shimbun';
import Interview from './components/Interview';
import Interview2 from './components/Interview2';
import Interview3 from './components/Interview3';
import Interview4 from './components/Interview4';
import Shimbun3 from './components/Shimbun3';

import './index.css';
import registerServiceWorker from './pwa/register';
import HomeButton from './components/HomeButton';

render(
  <Router history={history}>
    <React.Fragment>
    <Switch>
      <Route exact path='/' component={App} />
      <Route path='/register' component={Register} />
      <Route path='/login' component={Login} />
      <Route path='/login2' component={Login2} />
      <Route path='/login3' component={Login3} />
      <Route path='/login4' component={Login4} />
      <Route path='/loginoptions' component={LoginOptions} />
      <Route path='/loginoptions2' component={LoginOptions2} />
      <Route path='/blocks' component={Blocks} />
      <Route path='/directtokenverification' component={TokenAuthentication} />
      <Route path='/tokenverification' component={TokenAuthentication2} />
      <Route path='/tokenverificationpublickey' component={TokenAuthentication3} />
      <Route path='/phoneauthentication' component={PhoneAuthentication} />
      <Route path='/phoneauthentication2' component={PhoneAuthentication2} />
      <Route path='/otpauthentication' component={OTPAuthentication} />
      <Route path='/pincodeauthentication' component={PINCodeAuthentication} />
      <Route path='/otpauthentication2' component={OTPAuthentication2} />
      <Route path='/showtokens' component={ShowTokens} />
      <Route path='/showtokens2' component={ShowTokens2} />
      <Route path='/showtokens3' component={ShowTokens3} />
      <Route path='/secretpage' component={SecretPage} />
      <Route path='/algorithmoptions' component={AlgorithmOptions} />
      <Route path='/keysgenerator' component={KeysGenerator} />
      <Route path='/rs256signature' component={Rs256Signature} />
      <Route path='/uploadslip' component={UploadSlip} />
      <Route path='/uploadslip2' component={UploadSlip2} />
      <Route path='/uploadqrcode' component={UploadQRCode} />
      <Route path='/setmessage' component={SetMessage} />
      <Route path='/qrgenerator' component={QRCodeGenerator} />
      <Route path='/monitorsummary' component={MonitorSummary} />
      <Route path='/conduct-alexanderk' component={ConductAlexanderk} />
      <Route path='/conduct-anandat' component={ConductAnandat} />
      <Route path='/conduct-anantayak' component={ConductAnantayak} />
      <Route path='/conduct-angieo' component={ConductAngieo} />
      <Route path='/conduct-autp' component={ConductAutp} />
      <Route path='/conduct-billyz' component={ConductBillyz} />
      <Route path='/conduct-borwonr' component={ConductBorwonr} />
      <Route path='/conduct-carolync' component={ConductCarolync} />
      <Route path='/conduct-chaiwatt' component={ConductChaiwatt} />
      <Route path='/conduct-chatchawane' component={ConductChatchawane} />
      <Route path='/conduct-chayanind' component={ConductChayanind} />
      <Route path='/conduct-choosakp' component={ConductChoosakp} />
      <Route path='/conduct-danaiy' component={ConductDanaiy} />
      <Route path='/conduct-ericc' component={ConductEricc} />
      <Route path='/conduct-janicej' component={ConductJanicej} />
      <Route path='/conduct-jeerawita' component={ConductJeerawita} />
      <Route path='/conduct-jiaminb' component={ConductJiaminb} />
      <Route path='/conduct-kanina' component={ConductKanina} />
      <Route path='/conduct-kanokphonc' component={ConductKanokphonc} />
      <Route path='/conduct-kridsadad' component={ConductKridsadad} />
      <Route path='/conduct-loonweewatt' component={ConductLoonweewatt} />
      <Route path='/conduct-lulladaa' component={ConductLulladaa} />
      <Route path='/conduct-metapornc' component={ConductMetapornc} />
      <Route path='/conduct-michion' component={ConductMichion} />
      <Route path='/conduct-namont' component={ConductNamont} />
      <Route path='/conduct-napolp' component={ConductNapolp} />
      <Route path='/conduct-narongritn' component={ConductNarongritn} />
      <Route path='/conduct-naruporns' component={ConductNaruporns} />
      <Route path='/conduct-natsawittau' component={ConductNatsawittau} />
      <Route path='/conduct-nattasuth' component={ConductNattasuth} />
      <Route path='/conduct-natthaphati' component={ConductNatthaphati} />
      <Route path='/conduct-new' component={ConductNew} />
      <Route path='/conduct-nirunc' component={ConductNirunc} />
      <Route path='/conduct-nitchakarnt' component={ConductNitchakarnt} />
      <Route path='/conduct-patanins' component={ConductPatanins} />
      <Route path='/conduct-pattapongc' component={ConductPattapongc} />
      <Route path='/conduct-pattarananp' component={ConductPattarananp} />
      <Route path='/conduct-pisutk' component={ConductPisutk} />
      <Route path='/conduct-ratchadapornn' component={ConductRatchadapornn} />
      <Route path='/conduct-ratcharatp' component={ConductRatcharatp} />
      <Route path='/conduct-ronbanchoba' component={ConductRonbanchoba} />
      <Route path='/conduct-sanphets' component={ConductSanphets} />
      <Route path='/conduct-shintarok' component={ConductShintarok} />
      <Route path='/conduct-siwathornr' component={ConductSiwathornr} />
      <Route path='/conduct-somchaic' component={ConductSomchaic} />
      <Route path='/conduct-sreytiah' component={ConductSreytiah} />
      <Route path='/conduct-supachais' component={ConductSupachais} />
      <Route path='/conduct-supapimpisap' component={ConductSupapimpisap} />
      <Route path='/conduct-surateer' component={ConductSurateer} />
      <Route path='/conduct-surather' component={ConductSurateer} />
      <Route path='/conduct-surink' component={ConductSurink} />
      <Route path='/conduct-tarah' component={ConductTarah} />
      <Route path='/conduct-teerayutp' component={ConductTeerayutp} />
      <Route path='/conduct-thakhunk' component={ConductThakhunk} />
      <Route path='/conduct-thanyapatp' component={ConductThanyapatp} />
      <Route path='/conduct-thongchait' component={ConductThongchait} />
      <Route path='/conduct-thongchomphunutr' component={ConductThongchomphunutr} />
      <Route path='/conduct-tirawana' component={ConductTirawana} />
      <Route path='/conduct-uraveet' component={ConductUraveet} />
      <Route path='/conduct-wacharapongs' component={ConductWacharapongs} />
      <Route path='/conduct-winyuc' component={ConductWinyuc} />
      <Route path='/conduct-witchayapongp' component={ConductWitchayapongp} />
      <Route path='/conduct-worapotb' component={ConductWorapotb} />
      <Route path='/conduct-yanint' component={ConductYanint} />
      <Route path='/conduct-yaranyapohnk' component={ConductYaranyapohnk} />
      <Route path='/conduct-andrewl' component={ConductAndrewl} />
      <Route path='/conduct-panyaphatk' component={ConductPanyaphatk} />
      <Route path='/conduct-pongworakornp' component={ConductPongworakornp} />
      <Route path='/conduct-sunyal' component={ConductSunyal} />
      <Route path='/conduct-tanapolp' component={ConductTanapolp} />
      <Route path='/conduct-thomasm' component={ConductThomasm} />
      <Route path='/conduct-asdawutc' component={ConductAsdawutc} />
      <Route path='/conduct-panupats' component={ConductPanupats} />
      <Route path='/conduct-chanchita' component={ConductChanchita} />
      <Route path='/conduct-issariyapar' component={ConductIssariyapar} />
      <Route path='/conduct-jacquesp' component={ConductJacquesp} />
      <Route path='/conduct-matsakaj' component={ConductMatsakaj} />
      <Route path='/conduct-napasanunv' component={ConductNapasanunv} />
      <Route path='/conduct-naphatsorny' component={ConductNaphatsorny} />
      <Route path='/conduct-nutchan' component={ConductNutchan} />
      <Route path='/conduct-pawanratc' component={ConductPawanratc} />
      <Route path='/conduct-santis' component={ConductSantis} />
      <Route path='/conduct-wannatouchp' component={ConductWannatouchp} />
      <Route path='/conduct-crystalmd' component={ConductCrystalmd} />
      <Route path='/conduct-jamesrh' component={ConductJamesrh} />
      <Route path='/conduct-natthapony' component={ConductNatthapony} />
      <Route path='/conduct-nueas' component={ConductNueas} />
      <Route path='/conduct-karnts' component={ConductKarnts} />
      <Route path='/conduct-pakawadn' component={ConductPakawadn} />
      <Route path='/conduct-archirawishp' component={ConductArchirawishp} />
      <Route path='/conduct-praewpuns' component={ConductPraewpuns} />
      <Route path='/conduct-riradav' component={ConductRiradav} />
      <Route path='/conduct-suphodh' component={ConductSuphodh} />
      <Route path='/conduct-kittipatw' component={ConductKittipatw} />
      <Route path='/conduct-orawanp' component={ConductOrawanp} />
      <Route path='/conduct-sirawichu' component={ConductSirawichu} />
      <Route path='/conduct-pats' component={ConductPats} />
      <Route path='/conduct-manussaporne' component={ConductManussaporne} />
      <Route path='/conduct-surachett' component={ConductSurachett} />
      <Route path='/conduct-chaiyutv' component={ConductChaiyutv} />
      <Route path='/conduct-chakchaia' component={ConductChakchaia} />
      <Route path='/conduct-marcop' component={ConductMarcop} />
      <Route path='/conduct-pongnarts' component={ConductPongnarts} />
      <Route path='/conduct-shinehl' component={ConductShinehl} />
      <Route path='/conduct-suphatchayab' component={ConductSuphatchayab} />
      <Route path='/conduct-suteed' component={ConductSuteed} />
      <Route path='/conduct-vunqt' component={ConductVunqt} />
      <Route path='/conduct-athichonmf' component={ConductAthichonmf} />
      <Route path='/conduct-barbarab' component={ConductBarbarab} />
      <Route path='/conduct-jarunnops' component={ConductJarunnops} />
      <Route path='/conduct-kank' component={ConductKank} />
      <Route path='/conduct-kanyaphatp' component={ConductKanyaphatp} />
      <Route path='/conduct-marceld' component={ConductMarceld} />
      <Route path='/conduct-nannaphatp' component={ConductNannaphatp} />
      <Route path='/conduct-natdanaid' component={ConductNatdanaid} />
      <Route path='/conduct-panyasuphak' component={ConductPanyasuphak} />
      <Route path='/conduct-rattapongp' component={ConductRattapongp} />
      <Route path='/conduct-watcharapongb' component={ConductWatcharapongb} />
      <Route path='/conduct-narat' component={ConductNarat} />
      <Route path='/conduct-cheiax' component={ConductCheiax} />
      <Route path='/conduct-ornranatp' component={ConductOrnranatp} />
      <Route path='/conduct-naruekarink' component={ConductNaruekarink} />
      <Route path='/conduct-carinad' component={ConductCarinad} />
      <Route path='/conduct-ekasitw' component={ConductEkasitw} />
      <Route path='/conduct-naras' component={ConductNaras} />
      <Route path='/conduct-nattawuta' component={ConductNattawuta} />
      <Route path='/conduct-nichaj' component={ConductNichaj} />
      <Route path='/conduct-niwats' component={ConductNiwats} />
      <Route path='/conduct-praphatpongy' component={ConductPraphatpongy} />
      <Route path='/conduct-torritb' component={ConductTorritb} />
      <Route path='/conduct-benjaminb' component={ConductBenjaminb} />
      <Route path='/conduct-kansinees' component={ConductKansinees} />
      <Route path='/conduct-marks' component={ConductMarks} />
      <Route path='/conduct-marvins' component={ConductMarvins} />
      <Route path='/conduct-mitts' component={ConductMitts} />
      <Route path='/conduct-narns' component={ConductNarns} />
      <Route path='/conduct-tylerb' component={ConductTylerb} />
      <Route path='/conduct-wyonab' component={ConductWyonab} />
      <Route path='/conduct-zaidena' component={ConductZaidena} />
      <Route path='/conduct-amornpont' component={ConductAmornpont} />
      <Route path='/conduct-jasona' component={ConductJasona} />
      <Route path='/conduct-kosinm' component={ConductKosinm} />
      <Route path='/conduct-niratb' component={ConductNiratb} />
      <Route path='/conduct-patawank' component={ConductPatawank} />
      <Route path='/conduct-pawatchakornh' component={ConductPawatchakornh} />
      <Route path='/conduct-chanmethap' component={ConductChanmethap} />
      <Route path='/conduct-nithiss' component={ConductNithiss} />
      <Route path='/conduct-thanaip' component={ConductThanaip} />
      <Route path='/conduct-phusins' component={ConductPhusins} />
      <Route path='/conduct-piroontipl' component={ConductPiroontipl} />
      <Route path='/conduct-xinrongw' component={ConductXinrongw} />
      <Route path='/conduct-linh' component={ConductLinh} />
      <Route path='/conduct-nadaphatn' component={ConductNadaphatn} />
      <Route path='/conduct-nataphatn' component={ConductNataphatn} />
      <Route path='/conduct-naprachm' component={ConductNaprachm} />
      <Route path='/conduct-jaiklal' component={ConductJaiklal} />
      <Route path='/conduct-niksak' component={ConductNiksak} />
      <Route path='/conduct-paricharts' component={ConductParicharts} />
      <Route path='/conduct-phattarakritl' component={ConductPhattarakritl} />
      <Route path='/conduct-phuphumj' component={ConductPhuphumj} />
      <Route path='/conduct-piyabutrl' component={ConductPiyabutrl} />
      <Route path='/conduct-vaayuk' component={ConductVaayuk} />
      <Route path='/conduct-wichaic' component={ConductWichaic} />
      <Route path='/conduct-stefank' component={ConductStefank} />
      <Route path='/conduct-shosont' component={ConductShosont} />
      <Route path='/conduct-karlr' component={ConductKarlr} />
      <Route path='/conduct-sunchuym' component={ConductSunchuym} />
      <Route path='/conduct-pathikornk' component={ConductPathikornk} />
      <Route path='/conduct-ratarmontrees' component={ConductRatarmontrees} />
      <Route path='/conduct-kannikad' component={ConductKannikad} />
      <Route path='/conduct-zarawink' component={ConductZarawink} />
      <Route path='/conduct-johnh' component={ConductJohnh} />
      <Route path='/conduct-sombatt' component={ConductSombatt} />
      <Route path='/conduct-teeraratb' component={ConductTeeraratb} />
      <Route path='/conduct-chucheeps' component={ConductChucheeps} />
      <Route path='/conduct-rakchanokc' component={ConductRakchanokc} />
      <Route path='/conduct-narumolt' component={ConductNarumolt} />
      <Route path='/conduct-ratchadaporns' component={ConductRatchadaporns} />
      <Route path='/conduct-watcharapols' component={ConductWatcharapols} />
      <Route path='/conduct-wisutl' component={ConductWisutl} />
      <Route path='/conduct-pipatphongw' component={ConductPipatphongw} />
      <Route path='/conduct-fuengwichm' component={ConductFuengwichm} />
      <Route path='/conduct-kittisaks' component={ConductKittisaks} />
      <Route path='/conduct-siriphornm' component={ConductSiriphornm} />
      <Route path='/conduct-tarnnamthips' component={ConductTarnnamthips} />
      <Route path='/conduct-sukunyak' component={ConductSukunyak} />
      <Route path='/conduct-janyaporns' component={ConductJanyaporns} />
      <Route path='/conduct-rattanas' component={ConductRattanas} />
      <Route path='/conduct-phasinl' component={ConductPhasinl} />
      <Route path='/conduct-phurint' component={ConductPhurint} />
      <Route path='/conduct-matthewp' component={ConductMatthewp} />
      <Route path='/conduct-nonthapornk' component={ConductNonthapornk} />
      <Route path='/conduct-anuchaw' component={ConductAnuchaw} />
      <Route path='/conduct-lolas' component={ConductLolas} />
      <Route path='/conduct-jonathanc' component={ConductJonathanc} />
      <Route path='/conduct-ketkanoka' component={ConductKetkanoka} />
      <Route path='/conduct-pobkhunt' component={ConductPobkhunt} />
      <Route path='/conduct-pimphisal' component={ConductPimphisal} />
      <Route path='/conduct-purip' component={ConductPurip} />
      <Route path='/conduct-pimpidat' component={ConductPimpidat} />
      <Route path='/conduct-nechayas' component={ConductNechayas} />
      <Route path='/conduct-pawornwichw' component={ConductPawornwichw} />
      <Route path='/conduct-rakhunt' component={ConductRakhunt} />
      <Route path='/conduct-punnapatw' component={ConductPunnapatw} />
      <Route path='/conduct-amornphitk' component={ConductAmornphitk} />
      <Route path='/conduct-thantnyim' component={ConductThantnyim} />
      <Route path='/conduct-amornphant' component={ConductAmornphant} />
      <Route path='/conduct-piyachutc' component={ConductPiyachutc} />
      <Route path='/conduct-worapopk' component={ConductWorapopk} />
      <Route path='/conduct-annar' component={ConductAnnar} />
      <Route path='/conduct-darann' component={ConductDarann} />
      <Route path='/conduct-augusts' component={ConductAugusts} />
      <Route path='/conduct-thammachartt' component={ConductThammachartt} />
      <Route path='/conduct-andreif' component={ConductAndreif} />
      <Route path='/conduct-liudmilam' component={ConductLiudmilam} />
      <Route path='/conduct-porametn' component={ConductPorametn} />
      <Route path='/conduct-phimmadak' component={ConductPhimmadak} />
      <Route path='/conduct-jirananu' component={ConductJirananu} />
      <Route path='/conduct-pichamonc' component={ConductPichamonc} />
      <Route path='/conduct-parinb' component={ConductParinb} />
      <Route path='/conduct-thanachotec' component={ConductThanachotec} />
      <Route path='/conduct-wissarutm' component={ConductWissarutm} />
      <Route path='/conduct-pummad' component={ConductPummad} />
      <Route path='/conduct-choochaic' component={ConductChoochaic} />
      <Route path='/conduct-busayarinr' component={ConductBusayarinr} />
      <Route path='/conduct-aurathail' component={ConductAurathail} />
      <Route path='/conduct-paramir' component={ConductParamir} />
      <Route path='/conduct-salineeb' component={ConductSalineeb} />
      <Route path='/conduct-wannarats' component={ConductWannarats} />
      <Route path='/conduct-kittichoten' component={ConductKittichoten} />
      <Route path='/conduct-theerathasp' component={ConductTheerathasp} />
      <Route path='/conduct-anukulc' component={ConductAnukulc} />
      <Route path='/conduct-natchanonk' component={ConductNatchanonk} />
      <Route path='/conduct-punnawatk' component={ConductPunnawatk} />
      <Route path='/conduct-techathatw' component={ConductTechathatw} />
      <Route path='/conduct-yothsayaw' component={ConductYothsayaw} />
      <Route path='/conduct-puttd' component={ConductPuttd} />
      <Route path='/conduct-sirapopes' component={ConductSirapopes} />
      <Route path='/conduct-maytapornc' component={ConductMaytapornc} />
      <Route path='/conduct-pittayac' component={ConductPittayac} />
      <Route path='/conduct-pordeer' component={ConductPordeer} />
      <Route path='/conduct-pemikar' component={ConductPemikar} />
      <Route path='/conduct-pattarapony' component={ConductPattarapony} />
      <Route path='/conduct-piyanats' component={ConductPiyanats} />
      <Route path='/conduct-ratchaninp' component={ConductRatchaninp} />
      <Route path='/conduct-natnateep' component={ConductNatnateep} />
      <Route path='/conduct-bowwonlukc' component={ConductBowwonlukc} />
      <Route path='/conduct-poonkanuto' component={ConductPoonkanuto} />
      <Route path='/conduct-sengdaviengd' component={ConductSengdaviengd} />
      <Route path='/conduct-patwareek' component={ConductPatwareek} />
      <Route path='/conduct-yihaow' component={ConductYihaow} />
      <Route path='/conduct-aniwatl' component={ConductAniwatl} />
      <Route path='/conduct-eugenea' component={ConductEugenea} />
      <Route path='/conduct-wiyadaj' component={ConductWiyadaj} />
      <Route path='/conduct-thanasons' component={ConductThanasons} />
      <Route path='/conduct-naphatradaq' component={ConductNaphatradaq} />
      <Route path='/conduct-sathawathak' component={ConductSathawathak} />
      <Route path='/conduct-chayaphatk' component={ConductChayaphatk} />
      <Route path='/conduct-pasuthan' component={ConductPasuthan} />
      <Route path='/conduct-jaruwann' component={ConductJaruwann} />
      <Route path='/conduct-thornthepk' component={ConductThornthepk} />
      <Route path='/conduct-tirawutn' component={ConductTirawutn} />
      <Route path='/conduct-yuthanas' component={ConductYuthanas} />
      <Route path='/conduct-krittitatw' component={ConductKrittitatw} />
      <Route path='/conduct-phanuphongk' component={ConductPhanuphongk} />
      <Route path='/bioalexanderk' component={BioAlexanderk} />
      <Route path='/bioanandat' component={BioAnandat} />
      <Route path='/bioanantayak' component={BioAnantayak} />
      <Route path='/bioangieo' component={BioAngieo} />
      <Route path='/bioautp' component={BioAutp} />
      <Route path='/biobillyz' component={BioBillyz} />
      <Route path='/bioborwonr' component={BioBorwonr} />
      <Route path='/biocarolync' component={BioCarolync} />
      <Route path='/biochaiwatt' component={BioChaiwatt} />
      <Route path='/biochatchawane' component={BioChatchawane} />
      <Route path='/biochayanind' component={BioChayanind} />
      <Route path='/biochoosakp' component={BioChoosakp} />
      <Route path='/biodanaiy' component={BioDanaiy} />
      <Route path='/bioericc' component={BioEricc} />
      <Route path='/biojanicej' component={BioJanicej} />
      <Route path='/biojeerawita' component={BioJeerawita} />
      <Route path='/biojiaminb' component={BioJiaminb} />
      <Route path='/biokanina' component={BioKanina} />
      <Route path='/biokanokphonc' component={BioKanokphonc} />
      <Route path='/biokridsadad' component={BioKridsadad} />
      <Route path='/bioloonweewatt' component={BioLoonweewatt} />
      <Route path='/biolulladaa' component={BioLulladaa} />
      <Route path='/biometapornc' component={BioMetapornc} />
      <Route path='/biomichion' component={BioMichion} />
      <Route path='/bionamont' component={BioNamont} />
      <Route path='/bionapolp' component={BioNapolp} />
      <Route path='/bionarongritn' component={BioNarongritn} />
      <Route path='/bionaruporns' component={BioNaruporns} />
      <Route path='/bionatsawittau' component={BioNatsawittau} />
      <Route path='/bionattasuth' component={BioNattasuth} />
      <Route path='/bionatthaphati' component={BioNatthaphati} />
      <Route path='/bionew' component={BioNew} />
      <Route path='/bionirunc' component={BioNirunc} />
      <Route path='/bionitchakarnt' component={BioNitchakarnt} />
      <Route path='/biopatanins' component={BioPatanins} />
      <Route path='/biopattapongc' component={BioPattapongc} />
      <Route path='/biopattarananp' component={BioPattarananp} />
      <Route path='/biopisutk' component={BioPisutk} />
      <Route path='/bioratchadapornn' component={BioRatchadapornn} />
      <Route path='/bioratcharatp' component={BioRatcharatp} />
      <Route path='/bioronbanchoba' component={BioRonbanchoba} />
      <Route path='/biosanphets' component={BioSanphets} />
      <Route path='/bioshintarok' component={BioShintarok} />
      <Route path='/biosiwathornr' component={BioSiwathornr} />
      <Route path='/biosomchaic' component={BioSomchaic} />
      <Route path='/biosreytiah' component={BioSreytiah} />
      <Route path='/biosupachais' component={BioSupachais} />
      <Route path='/biosupapimpisap' component={BioSupapimpisap} />
      <Route path='/biosurateer' component={BioSurateer} />
      <Route path='/biosurink' component={BioSurink} />
      <Route path='/biotarah' component={BioTarah} />
      <Route path='/bioteerayutp' component={BioTeerayutp} />
      <Route path='/biothakhunk' component={BioThakhunk} />
      <Route path='/biothanyapatp' component={BioThanyapatp} />
      <Route path='/biothongchait' component={BioThongchait} />
      <Route path='/biothongchomphunutr' component={BioThongchomphunutr} />
      <Route path='/biotirawana' component={BioTirawana} />
      <Route path='/biouraveet' component={BioUraveet} />
      <Route path='/biowacharapongs' component={BioWacharapongs} />
      <Route path='/biowinyuc' component={BioWinyuc} />
      <Route path='/biowitchayapongp' component={BioWitchayapongp} />
      <Route path='/bioworapotb' component={BioWorapotb} />
      <Route path='/bioyanint' component={BioYanint} />
      <Route path='/bioyaranyapohnk' component={BioYaranyapohnk} />
      <Route path='/bioandrewl' component={BioAndrewl} />
      <Route path='/biopanyaphatk' component={BioPanyaphatk} />
      <Route path='/biopongworakornp' component={BioPongworakornp} />
      <Route path='/biosunyal' component={BioSunyal} />
      <Route path='/biotanapolp' component={BioTanapolp} />
      <Route path='/biothomasm' component={BioThomasm} />
      <Route path='/bioasdawutc' component={BioAsdawutc} />
      <Route path='/biopanupats' component={BioPanupats} />
      <Route path='/biochanchita' component={BioChanchita} />
      <Route path='/bioissariyapar' component={BioIssariyapar} />
      <Route path='/biojacquesp' component={BioJacquesp} />
      <Route path='/biomatsakaj' component={BioMatsakaj} />
      <Route path='/bionapasanunv' component={BioNapasanunv} />
      <Route path='/bionaphatsorny' component={BioNaphatsorny} />
      <Route path='/bionutchan' component={BioNutchan} />
      <Route path='/biopawanratc' component={BioPawanratc} />
      <Route path='/biosantis' component={BioSantis} />
      <Route path='/biowannatouchp' component={BioWannatouchp} />
      <Route path='/biocrystalmd' component={BioCrystalmd} />
      <Route path='/biojamesrh' component={BioJamesrh} />
      <Route path='/bionatthapony' component={BioNatthapony} />
      <Route path='/bionueas' component={BioNueas} />
      <Route path='/bioarchirawishp' component={BioArchirawishp} />
      <Route path='/biokarnts' component={BioKarnts} />
      <Route path='/biokittipatw' component={BioKittipatw} />
      <Route path='/biomanussaporne' component={BioManussaporne} />
      <Route path='/bioorawanp' component={BioOrawanp} />
      <Route path='/biopakawadn' component={BioPakawadn} />
      <Route path='/biopats' component={BioPats} />
      <Route path='/biopraewpuns' component={BioPraewpuns} />
      <Route path='/biosirawichu' component={BioSirawichu} />
      <Route path='/biosuphodh' component={BioSuphodh} />
      <Route path='/biosurachett' component={BioSurachett} />
      <Route path='/bioriradav' component={BioRiradav} />
      <Route path='/biochaiyutv' component={BioChaiyutv} />
      <Route path='/biochakchaia' component={BioChakchaia} />
      <Route path='/biomarcop' component={BioMarcop} />
      <Route path='/biopongnarts' component={BioPongnarts} />
      <Route path='/bioshinehl' component={BioShinehl} />
      <Route path='/biosuphatchayab' component={BioSuphatchayab} />
      <Route path='/biosuteed' component={BioSuteed} />
      <Route path='/biovunqt' component={BioVunqt} />
      <Route path='/bioathichonmf' component={BioAthichonmf} />
      <Route path='/biobarbarab' component={BioBarbarab} />
      <Route path='/biojarunnops' component={BioJarunnops} />
      <Route path='/biokank' component={BioKank} />
      <Route path='/biokanyaphatp' component={BioKanyaphatp} />
      <Route path='/biomarceld' component={BioMarceld} />
      <Route path='/bionannaphatp' component={BioNannaphatp} />
      <Route path='/bionatdanaid' component={BioNatdanaid} />
      <Route path='/biopanyasuphak' component={BioPanyasuphak} />
      <Route path='/biorattapongp' component={BioRattapongp} />
      <Route path='/biowatcharapongb' component={BioWatcharapongb} />
      <Route path='/bionarat' component={BioNarat} />
      <Route path='/biocheiax' component={BioCheiax} />
      <Route path='/bioornranatp' component={BioOrnranatp} />
      <Route path='/bionaruekarink' component={BioNaruekarink} />
      <Route path='/biocarinad' component={BioCarinad} />
      <Route path='/bioekasitw' component={BioEkasitw} />
      <Route path='/bionaras' component={BioNaras} />
      <Route path='/bionattawuta' component={BioNattawuta} />
      <Route path='/bionichaj' component={BioNichaj} />
      <Route path='/bioniwats' component={BioNiwats} />
      <Route path='/biopraphatpongy' component={BioPraphatpongy} />
      <Route path='/biotorritb' component={BioTorritb} />
      <Route path='/biobenjaminb' component={BioBenjaminb} />
      <Route path='/biokansinees' component={BioKansinees} />
      <Route path='/biomarks' component={BioMarks} />
      <Route path='/biomarvins' component={BioMarvins} />
      <Route path='/biomitts' component={BioMitts} />
      <Route path='/bionarns' component={BioNarns} />
      <Route path='/biotylerb' component={BioTylerb} />
      <Route path='/biowyonab' component={BioWyonab} />
      <Route path='/biozaidena' component={BioZaidena} />
      <Route path='/bioamornpont' component={BioAmornpont} />
      <Route path='/biojasona' component={BioJasona} />
      <Route path='/biokosinm' component={BioKosinm} />
      <Route path='/bioniratb' component={BioNiratb} />
      <Route path='/biopatawank' component={BioPatawank} />
      <Route path='/biopawatchakornh' component={BioPawatchakornh} />
      <Route path='/biochanmethap' component={BioChanmethap} />
      <Route path='/bionithiss' component={BioNithiss} />
      <Route path='/biothanaip' component={BioThanaip} />
      <Route path='/biophusins' component={BioPhusins} />
      <Route path='/biopiroontipl' component={BioPiroontipl} />
      <Route path='/bioxinrongw' component={BioXinrongw} />
      <Route path='/biolinh' component={BioLinh} />
      <Route path='/bionadaphatn' component={BioNadaphatn} />
      <Route path='/bionataphatn' component={BioNataphatn} />
      <Route path='/bionaprachm' component={BioNaprachm} />
      <Route path='/biojaiklal' component={BioJaiklal} />
      <Route path='/bioniksak' component={BioNiksak} />
      <Route path='/bioparicharts' component={BioParicharts} />
      <Route path='/biophattarakritl' component={BioPhattarakritl} />
      <Route path='/biophuphumj' component={BioPhuphumj} />
      <Route path='/biopiyabutrl' component={BioPiyabutrl} />
      <Route path='/biovaayuk' component={BioVaayuk} />
      <Route path='/biowichaic' component={BioWichaic} />
      <Route path='/biostefank' component={BioStefank} />
      <Route path='/bioshosont' component={BioShosont} />
      <Route path='/biokarlr' component={BioKarlr} />
      <Route path='/biosunchuym' component={BioSunchuym} />
      <Route path='/biopathikornk' component={BioPathikornk} />
      <Route path='/biosalineeb' component={BioSalineeb} />
      <Route path='/bioanukulc' component={BioAnukulc} />
      <Route path='/bionatchanonk' component={BioNatchanonk} />
      <Route path='/biopunnawatk' component={BioPunnawatk} />
      <Route path='/biotechathatw' component={BioTechathatw} />
      <Route path='/bioyothsayaw' component={BioYothsayaw} />
      <Route path='/bioputtd' component={BioPuttd} />
      <Route path='/biosirapopes' component={BioSirapopes} />
      <Route path='/biopatwareek' component={BioPatwareek} />
      <Route path='/biopittayac' component={BioPittayac} />
      <Route path='/biopordeer' component={BioPordeer} />
      <Route path='/biopemikar' component={BioPemikar} />
      <Route path='/biopattarapony' component={BioPattarapony} />
      <Route path='/biopiyanats' component={BioPiyanats} />
      <Route path='/bioratchaninp' component={BioRatchaninp} />
      <Route path='/bionatnateep' component={BioNatnateep} />
      <Route path='/biobowwonlukc' component={BioBowwonlukc} />
      <Route path='/biowannarats' component={BioWannarats} />
      <Route path='/biomaytapornc' component={BioMaytapornc} />
      <Route path='/bionechayas' component={BioNechayas} />
      <Route path='/biopawornwichw' component={BioPawornwichw} />
      <Route path='/bioratchadaporns' component={BioRatchadaporns} />
      <Route path='/biotarnnamthips' component={BioTarnnamthips} />
      <Route path='/biorattanas' component={BioRattanas} />
      <Route path='/biorakhunt' component={BioRakhunt} />
      <Route path='/biopobkhunt' component={BioPobkhunt} />
      <Route path='/bioannar' component={BioAnnar} />
      <Route path='/biodarann' component={BioDarann} />
      <Route path='/biopunnapatw' component={BioPunnapatw} />
      <Route path='/biopimphisal' component={BioPimphisal} />
      <Route path='/biononthapornk' component={BioNonthapornk} />
      <Route path='/biosombatt' component={BioSombatt} />
      <Route path='/bioteeraratb' component={BioTeeraratb} />
      <Route path='/biochucheeps' component={BioChucheeps} />
      <Route path='/biorakchanokc' component={BioRakchanokc} />
      <Route path='/biowatcharapols' component={BioWatcharapols} />
      <Route path='/bionarumolt' component={BioNarumolt} />
      <Route path='/biowisutl' component={BioWisutl} />
      <Route path='/biopipatphongw' component={BioPipatphongw} />
      <Route path='/biofuengwichm' component={BioFuengwichm} />
      <Route path='/biokittisaks' component={BioKittisaks} />
      <Route path='/biosiriphornm' component={BioSiriphornm} />
      <Route path='/biophasinl' component={BioPhasinl} />
      <Route path='/biosukunyak' component={BioSukunyak} />
      <Route path='/bioanuchaw' component={BioAnuchaw} />
      <Route path='/biojanyaporns' component={BioJanyaporns} />
      <Route path='/biololas' component={BioLolas} />
      <Route path='/biophurint' component={BioPhurint} />
      <Route path='/biomatthewp' component={BioMatthewp} />
      <Route path='/biojonathanc' component={BioJonathanc} />
      <Route path='/biopurip' component={BioPurip} />
      <Route path='/biopimpidat' component={BioPimpidat} />
      <Route path='/bioketkanoka' component={BioKetkanoka} />
      <Route path='/bioamornphitk' component={BioAmornphitk} />
      <Route path='/biothantnyim' component={BioThantnyim} />
      <Route path='/bioamornphant' component={BioAmornphant} />
      <Route path='/biothammachartt' component={BioThammachartt} />
      <Route path='/biopiyachutc' component={BioPiyachutc} />
      <Route path='/bioandreif' component={BioAndreif} />
      <Route path='/bioliudmilam' component={BioLiudmilam} />
      <Route path='/bioaugusts' component={BioAugusts} />
      <Route path='/bioworapopk' component={BioWorapopk} />
      <Route path='/bioporametn' component={BioPorametn} />
      <Route path='/biojirananu' component={BioJirananu} />
      <Route path='/biopichamonc' component={BioPichamonc} />
      <Route path='/bioparinb' component={BioParinb} />
      <Route path='/biophimmadak' component={BioPhimmadak} />
      <Route path='/biojohnh' component={BioJohnh} />
      <Route path='/bioratarmontrees' component={BioRatarmontrees} />
      <Route path='/biokannikad' component={BioKannikad} />
      <Route path='/biozarawink' component={BioZarawink} />
      <Route path='/biowissarutm' component={BioWissarutm} />
      <Route path='/biopummad' component={BioPummad} />
      <Route path='/biochoochaic' component={BioChoochaic} />
      <Route path='/biobusayarinr' component={BioBusayarinr} />
      <Route path='/bioaurathail' component={BioAurathail} />
      <Route path='/biokittichoten' component={BioKittichoten} />
      <Route path='/biotheerathasp' component={BioTheerathasp} />
      <Route path='/biopoonkanuto' component={BioPoonkanuto} />
      <Route path='/biosengdaviengd' component={BioSengdaviengd} />
      <Route path='/bioparamir' component={BioParamir} />
      <Route path='/biothanachotec' component={BioThanachotec} />
      <Route path='/bioyihaow' component={BioYihaow} />
      <Route path='/bioaniwatl' component={BioAniwatl} />
      <Route path='/bioeugenea' component={BioEugenea} />
      <Route path='/biowiyadaj' component={BioWiyadaj} />
      <Route path='/biothanasons' component={BioThanasons} />
      <Route path='/bionaphatradaq' component={BioNaphatradaq} />
      <Route path='/biosathawathak' component={BioSathawathak} />
      <Route path='/biochayaphatk' component={BioChayaphatk} />
      <Route path='/biopasuthan' component={BioPasuthan} />
      <Route path='/biojaruwann' component={BioJaruwann} />
      <Route path='/biothornthepk' component={BioThornthepk} />
      <Route path='/biotirawutn' component={BioTirawutn} />
      <Route path='/bioyuthanas' component={BioYuthanas} />
      <Route path='/biokrittitatw' component={BioKrittitatw} />
      <Route path='/biophanuphongk' component={BioPhanuphongk} />
      <Route path='/dojos' component={Dojos} />
      <Route path='/classes' component={AllClasses} />
      <Route path='/classesrenbukan' component={ClassesRenbukan} />
      <Route path='/classesbmz' component={ClassesBMZ} />
      <Route path='/classestuksomrangsit' component={ClassesTukSomRangsit} />
      <Route path='/classestuksomromkaow' component={ClassesTukSomRomKaow} />
      <Route path='/classessattahip' component={ClassesSattahip} />
      <Route path='/classeschiangmai' component={ClassesChiangMai} />
      <Route path='/classeschula' component={ClassesChula} />
      <Route path='/classeskorat' component={ClassesKorat} />
      <Route path='/classeswongwianyai' component={ClassesWongwianYai} />
      <Route path='/classesfudokan' component={ClassesFudokan} />
      <Route path='/classeslumpini' component={ClassesLumpini} />
      <Route path='/classesmasakatsu' component={ClassesMasakatsu} />
      <Route path='/rosterrenbukan' component={RosterRenbukan} />
      <Route path='/rosterchiangmai' component={RosterChiangmai} />
      <Route path='/rostertuksom' component={RosterTuksom} />
      <Route path='/rosterchula' component={RosterChula} />
      <Route path='/rosterkorat' component={RosterKorat} />
      <Route path='/rosterbmz' component={RosterBMZ} />
      <Route path='/rosterwongwianyai' component={RosterWongwianyai} />
      <Route path='/rostersattahip' component={RosterSattahip} />
      <Route path='/rostermasakatsu' component={RosterMasakatsu} />
      <Route path='/rosterlumpini' component={RosterLumpini} />
      <Route path='/rosterphrakhanong' component={RosterPhraKhanong} />
      <Route path='/rosterfudokan' component={RosterFudokan} />
      <Route path='/rosterall' component={RosterAll} />
      <Route path='/test080325' component={Test080325} />
      <Route path='/test230325' component={Test230325} />
      <Route path='/test140625' component={Test140625} />
      <Route path='/test220625' component={Test220625} />
      <Route path='/test070925' component={Test070925} />
      <Route path='/test140925' component={Test140925} />
      <Route path='/test071225' component={Test071225} />
      <Route path='/test211225' component={Test211225} />
      <Route path='/test150326' component={Test150326} />
      <Route path='/test220326' component={Test220326} />
      <Route path='/test140626' component={Test140626} />
      <Route path='/test210626' component={Test210626} />
      <Route path='/test200926' component={Test200926} />
      <Route path='/test270926' component={Test270926} />
      <Route path='/testresults080325' component={TestResults080325} />
      <Route path='/testresults230325' component={TestResults230325} />
      <Route path='/testresults140625' component={TestResults140625} />
      <Route path='/testresults220625' component={TestResults220625} />
      <Route path='/testresults070925' component={TestResults070925} />
      <Route path='/testresults140925' component={TestResults140925} />
      <Route path='/testresults071225' component={TestResults071225} />
      <Route path='/testresults211225' component={TestResults211225} />
      <Route path='/testresults150326' component={TestResults150326} />
      <Route path='/testresults220326' component={TestResults220326} />
      <Route path='/testresults140626' component={TestResults140626} />
      <Route path='/testresults210626' component={TestResults210626} />
      <Route path='/testresults200926' component={TestResults200926} />
      <Route path='/testresults270926' component={TestResults270926} />
      <Route path='/sendemail' component={SendEmailForm} />
      <Route path='/meetingmembers' component={MeetingMembers} />
      <Route path='/transaction-pool' component={TransactionPool} />
      <Route path='/shop' component={Shop} />
      <Route path='/shop-shirts' component={ShopShirts} />
      <Route path='/shop-shirts1' component={ShopShirts1} />
      <Route path='/shop-shirts2' component={ShopShirts2} />
      <Route path='/shop-shirts3' component={ShopShirts3} />
      <Route path='/shop-shirts4' component={ShopShirts4} />
      <Route path='/uploadshirts1' component={UploadShirts1} />
      <Route path='/uploadshirts2' component={UploadShirts2} />
      <Route path='/uploadshirts3' component={UploadShirts3} />
      <Route path='/uploadshirts4' component={UploadShirts4} />
      <Route path='/shop-gi' component={ShopGi} />
      <Route path='/shop-hakama-belts' component={ShopHakamaBelts} />
      <Route path='/shop-accessories' component={ShopAccessories} />
      <Route path='/shop-weapons' component={ShopWeapons} />
      <Route path='/instructors' component={Instructors} />
      <Route path='/seminar041025' component={Seminar041025} />
      <Route path='/seminar051025' component={Seminar051025} />
      <Route path='/seminarbmz1' component={SeminarBMZ1} />
      <Route path='/seminarbmz2' component={SeminarBMZ2} />
      <Route path='/seminarchiangmai1' component={SeminarChiangmai1} />
      <Route path='/seminarchiangmai2' component={SeminarChiangmai2} />
      <Route path='/seminarbmz1' component={SeminarBMZ1} />
      <Route path='/seminarbmz2' component={SeminarBMZ2} />
      <Route path='/seminarchina1' component={SeminarChina1} />
      <Route path='/seminarchina2' component={SeminarChina2} />
      <Route path='/seminarchula1' component={SeminarChula1} />
      <Route path='/seminarchula2' component={SeminarChula2} />
      <Route path='/seminardindang1' component={SeminarDindang1} />
      <Route path='/seminardindang2' component={SeminarDindang2} />
      <Route path='/seminarfudokan1' component={SeminarFudokan1} />
      <Route path='/seminarfudokan2' component={SeminarFudokan2} />
      <Route path='/seminarhongkong1' component={SeminarHongkong1} />
      <Route path='/seminarhongkong2' component={SeminarHongkong2} />
      <Route path='/seminarmalaysia1' component={SeminarMalaysia1} />
      <Route path='/seminarmalaysia2' component={SeminarMalaysia2} />
      <Route path='/seminarmarine1' component={SeminarMarine1} />
      <Route path='/seminarmarine2' component={SeminarMarine2} />
      <Route path='/seminarwongwianyai1' component={SeminarWongwianyai1} />
      <Route path='/seminarwongwianyai2' component={SeminarWongwianyai2} />
      <Route path='/seminarmasakatsu1' component={SeminarMasakatsu1} />
      <Route path='/seminarmasakatsu2' component={SeminarMasakatsu2} />
      <Route path='/seminarkorat1' component={SeminarKorat1} />
      <Route path='/seminarkorat2' component={SeminarKorat2} />
      <Route path='/seminarsingapore1' component={SeminarSingapore1} />
      <Route path='/seminarsingapore2' component={SeminarSingapore2} />
      <Route path='/seminartuksom1' component={SeminarTuksom1} />
      <Route path='/seminartuksom2' component={SeminarTuksom2} />
      <Route path='/certificateslist' component={CertificatesList} />
      <Route path='/goshinjitsu' component={GoshinJitsu} />
      <Route path='/weaponsclass' component={WeaponsClass} />
      <Route path='/forgetpassword' component={ForgetPassword} />
      <Route path='/resetpassword' component={ResetPassword} />
      <Route path='/paymentmethods' component={PaymentMethods} />
      <Route path='/creditcardoptions' component={CreditcardOptions} />
      <Route path='/claimcredits100' component={ClaimCredits100} />
      <Route path='/logincredits100' component={LoginCredits100} />
      <Route path='/creditcard100' component={StripePage100} />
      <Route path='/testrecords' component={TestRecords} />
      <Route path='/forms' component={Forms} />
      <Route path='/search' component={Search} />
      <Route path='/articles' component={Articles} />
      <Route path='/shimbun' component={Shimbun} />
      <Route path='/interview' component={Interview} />
      <Route path='/interview2' component={Interview2} />
      <Route path='/interview3' component={Interview3} />
      <Route path='/interview4' component={Interview4} />
      <Route path='/shimbun3' component={Shimbun3} />
    </Switch>
    <HomeButton />
    </React.Fragment>
  </Router>,
  document.getElementById('root')
);

registerServiceWorker();
